// extracted by mini-css-extract-plugin
export var CheckBox = "default-module--CheckBox--mPCC7";
export var Radio = "default-module--Radio--DNXeI";